import { WeightUnit } from "@/Common/Utilities/Units/Units";

class BritishColumbiaObstetricalFileMetadata {
    public SignificantContributorIds: string[] = [];
    public SubsequentVisitsTableWeightUnit: WeightUnit;
    public CommentsAndFollowUpContributorContactIds: string[] = [];
    public IsReuseVitalSignOptionSet: boolean;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileMetadata>) {
        this.SubsequentVisitsTableWeightUnit = sessionStore.useMetricSystemAsDefault ? WeightUnit.Kilogram : WeightUnit.Pound;
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileMetadata };
